exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendarBox {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: calc(100% - 50px);\n  margin-left: 25px;\n  min-height: 100px;\n  padding: 5px;\n  background: rgba(255, 130, 107, 0.3);\n  margin-bottom: 5px; }\n  .calendarBox .dateBox {\n    display: inline-block;\n    width: 90px;\n    height: 90px;\n    background: white;\n    margin-right: 10px;\n    text-align: center; }\n    .calendarBox .dateBox .month {\n      text-transform: uppercase;\n      font-weight: bold;\n      color: black; }\n    .calendarBox .dateBox .day {\n      font-size: 40px;\n      line-height: 40px; }\n    .calendarBox .dateBox .year {\n      font-weight: bolder; }\n  .calendarBox .textBlock {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    display: inline-block; }\n    .calendarBox .textBlock .heading {\n      font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/main/calendarbox/calendarbox.component.scss
// module id = 312
// module chunks = 1